import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c7bb6946"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "payment-success d-flex flex-column align-items-center justify-content-center" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "display-4 mb-4" }, "🎉 Payment Sucessful!", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "lead mb-4" }, "Thank you for your support. Get ready to supercharge your job search!", -1))

import { onMounted } from "vue";
import confetti from "canvas-confetti";
import store from "../store";


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentSuccess',
  setup(__props) {

onMounted(async () => {
  const user = await store.getters["user/getLoggedInUser"];
  console.log(user.email);
  (window as any).rewardful("convert", { email: user.email });
  // Trigger confetti animation
  confetti({
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 },
  });
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_router_link, {
        to: "/dashboard",
        class: "btn btn-primary btn-lg"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Continue to Dashboard ")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})